import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/usr/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import React from "react";
var __jsx = React.createElement;
import { Component, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import stl from "./SharedPopUp.module.css";
var PopupBody = function PopupBody(_ref) {
  var children = _ref.children,
    oowh = _ref.oowh;
  var ref = useRef(null);
  useEffect(function () {
    if (ref.current) {
      ref.current.style.minHeight = "".concat(ref.current.scrollHeight, "px");
    }
  }, [ref]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: [stl.genralModalbody, oowh && stl.oowhModalBody].join(" ")
  }, /*#__PURE__*/React.createElement("div", null, children));
};
var SharedPopUp = /*#__PURE__*/function (_Component) {
  function SharedPopUp(props) {
    var _this;
    _classCallCheck(this, SharedPopUp);
    _this = _callSuper(this, SharedPopUp, [props]);
    _this.canUseDOM = __IS_CSR__;
    _this.state = {
      modalClassName: _this.props.className ? _this.props.className : undefined
    };
    return _this;
  }
  _inherits(SharedPopUp, _Component);
  return _createClass(SharedPopUp, [{
    key: "renderPopUpHTML",
    value: function renderPopUpHTML() {
      var _this2 = this,
        _this$props$maxWidth;
      this.props.show && (document.body.style.overflow = this.props.show ? "hidden" : "");
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.show && /*#__PURE__*/React.createElement("div", {
        className: [stl.genralPopUp, stl.showGenralPopUp, this.state.modalClassName].join(" "),
        onClick: function onClick(e) {
          if (e.target === e.currentTarget) {
            _this2.props.onClose();
            document.body.style.overflow = "";
          }
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: (_this$props$maxWidth = this.props.maxWidth) !== null && _this$props$maxWidth !== void 0 ? _this$props$maxWidth : "100%"
        },
        className: [stl.genralPopUpContent, this.props.oowh && stl.changeMinHeight].join(" ")
      }, !this.props.hideCloseBtn && /*#__PURE__*/React.createElement("span", {
        className: stl.closeGenralPopUp,
        onClick: function onClick() {
          _this2.props.onClose();
          document.body.style.overflow = "";
        }
      }), /*#__PURE__*/React.createElement(PopupBody, {
        oowh: this.props.oowh
      }, this.props.children))));
    }
  }, {
    key: "render",
    value: function render() {
      return this.canUseDOM ? (/*#__PURE__*/createPortal(this.renderPopUpHTML(), document.getElementById("BodyPortal"))) : /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  }]);
}(Component);
export default SharedPopUp;